import { useActiveAddress } from "@arweave-wallet-kit/react"
import { useQuery } from "@tanstack/react-query"

import { useAo } from "../ao/ao"
import getUserLockedTokens from "../ao/locker-api"
import { getPoolInfo, getUserBalance } from "../ao/pool"

function usePoolShare(poolId: string) {
  const ao = useAo()
  const account = useActiveAddress()

  return useQuery({
    queryKey: ["poolShares", poolId, account],
    queryFn: async () => {
      console.log(`Query poolShares for ${poolId} and ${account}`)
      let userShares = 0
      let lockedUserShares = 0

      const poolInfo = await getPoolInfo(poolId, ao)
      const totalShares = poolInfo.totalSupply

      if (!account) {
        return {
          userShares,
          totalShares,
          lockedUserShares,
        }
      }

      const [userBalance, lockResp] = await Promise.all([
        getUserBalance(poolId, account, ao),
        getUserLockedTokens(account, poolId, ao),
      ])
      const lockedUserBalance = lockResp?.Amount

      if (totalShares && userBalance) {
        userShares = totalShares ? (Number(userBalance) / Number(totalShares)) * 100 : 0
      }

      if (totalShares && lockedUserBalance) {
        lockedUserShares = totalShares ? (Number(lockedUserBalance) / Number(totalShares)) * 100 : 0
      }

      return {
        userShares,
        totalShares,
        lockedUserShares,
      }
    },
    enabled: !!account,
    staleTime: 1000 * 3600,
  })
}

export default usePoolShare
